// Определяет, запущено ли приложение как нативный APK (Capacitor) или как
// обычная веб-страница. Используется, чтобы выбрать нативное распознавание речи
// вместо браузерного. В вебе Capacitor не подгружен — возвращаем false.

import { Capacitor } from '@capacitor/core'

export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform()
  } catch {
    return false
  }
}
